import React, { useState } from 'react';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import Col from '../layout/Col';
import Title from '../forms/Title';
import Heading from '../forms/Heading';
import Button from '../forms/Button';

const WashCount = ({ ...props }) => {

    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(10);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.washCount)
                .then(res => setData({ today: 0, yesterday: 0, ...res }))
                .catch(ex => console.error(ex))
        }
    }, 60000)

    return (
        <Col align='flex-start'>
            {!fetchData && <Button onClick={() => setFetchData(10)}>Refresh Widget</Button>}
            <Title>Today: {data.today}</Title>
            <Heading>Yesterday: {data.yesterday}</Heading>
        </Col>
    );
}

export default WashCount;